module.exports = __webpack_public_path__ + "img/documentation.82688fd8.svg";